import { createContext, useContext } from 'react';
// Extending IntlShape is needed for accurate autocomplete, ignored as re-implementing all the functions is un-needed
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore-next-line
export const IntlContext = createContext({});
export const useIntlContext = () => useContext(IntlContext);
//# sourceMappingURL=intl-context.js.map